import { fallback } from "@tanstack/router-zod-adapter";
import { z } from "zod";
import { DataIdSchema } from "./auth";
import { MESSAGE_TAG } from "./message";

export const PresignPayloadSchema = z.object({
	file_name: z.string(),
	file: z.any(),
});

export type PresignPayloadSchema = z.infer<typeof PresignPayloadSchema>;

export const GalleryListSearchSchema = z.object({
	tab: fallback(z.enum(["all", "images", "video"]), "all").default("all"),
	view: DataIdSchema.optional(),
	edit: DataIdSchema.optional(),
	deleted: z.boolean().optional(),
	export: z.boolean().optional(),
	select: z.boolean().optional(),
	tag: z.nativeEnum(MESSAGE_TAG).optional(),
});

export const GalleriesCheckSchema = z.object({
	ids: z.array(
		z.object({
			id: z.number().int(),
			file_id: z.string(),
			created_at: z.string(),
			updated_at: z.string(),
			checked: z.boolean().default(false),
		}),
	),
});

export type GalleriesCheckSchema = z.infer<typeof GalleriesCheckSchema>;
